import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Contact Person
function createContactPerson(params: any) {
    const baseUrl = `/cper/createcper`;
    return api.create(`${baseUrl}`, params);
}
// update Contact Person
function updateContactPerson(params: any) {
    const baseUrl = '/cper/updatecper';
    return api.update(`${baseUrl}`, params);
}

// get all Contact Persons
function getAllContactPerson(params: any) {
    const baseUrl = '/cper/getcperlist';
    return api.create(`${baseUrl}`, params);
}

// get Contact Person
function getContactPerson(params: any) {
    const baseUrl = '/cper/getcper';
    return api.create(`${baseUrl}`, params);
}

export { createContactPerson, updateContactPerson, getAllContactPerson, getContactPerson };
